import type {
    GetUniversitiesResponseType
} from "./type";
import {
    request
} from "../request";

const getUniversities = async (): Promise<GetUniversitiesResponseType> => {
    return await request<GetUniversitiesResponseType>("/staticData/getUniversities", {
        method: "GET"
    });
};

export default getUniversities;
